import { GraphAttachment } from "../redux/outlook/outlook.types";

export const parseEmails = (value: string): string[] => {
  return value
    .split(/[,;\n]/)
    .map((email) => email.trim())
    .filter((email) => email.length > 0);
};

export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result || "");
      const base64 = result.includes(",") ? result.split(",")[1] : result;
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};


export const getExtension = (fileName: string): string => {
  const parts = fileName.split(".");
  if (parts.length < 2) {
    return "";
  }
  return parts[parts.length - 1].toLowerCase();
};

export const formatFileSize = (sizeInBytes?: number): string => {
  if (!sizeInBytes || sizeInBytes <= 0) {
    return "0 B";
  }

  if (sizeInBytes < 1024) {
    return `${sizeInBytes} B`;
  }

  const sizeInKb = sizeInBytes / 1024;
  if (sizeInKb < 1024) {
    return `${sizeInKb.toFixed(1)} KB`;
  }

  const sizeInMb = sizeInKb / 1024;
  return `${sizeInMb.toFixed(1)} MB`;
};


export const isImageAttachment = (attachment: GraphAttachment): boolean => {
  const contentType = (attachment.contentType || "").toLowerCase();
  const extension = getExtension(attachment.name || "");

  return (
    contentType.startsWith("image/") ||
    ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"].includes(extension)
  );
};

export const base64ToArrayBuffer = (base64: string): ArrayBuffer => {
  const byteCharacters = window.atob(base64);
  const byteArray = new Uint8Array(byteCharacters.length);

  for (let index = 0; index < byteCharacters.length; index += 1) {
    byteArray[index] = byteCharacters.charCodeAt(index);
  }

  return byteArray.buffer;
};

export const base64ToBlob = (base64: string, contentType: string): Blob => {
  const byteCharacters = window.atob(base64);
  const byteArrays: ArrayBuffer[] = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);

    for (let index = 0; index < slice.length; index += 1) {
      byteNumbers[index] = slice.charCodeAt(index);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray.buffer as ArrayBuffer);
  }

  return new Blob(byteArrays, {
    type: contentType || "application/octet-stream",
  });
};


export const isCurrentPathMailBox = (path: string): boolean => {
  const mailboxPaths = ["/api/v1/portal/inbox"];
  return mailboxPaths.includes(path);
}